<template>
  <div
    v-if="url"
    v-loading="pdfLoading"
    class="detail-pdf infinite-list"
    style="overflow-y: auto; overflow-x: hidden"
    infinite-scroll-distance="40"
    v-infinite-scroll="loadPage"
  >
    <pdf
      style="width: 100%"
      ref="pdf"
      v-for="i in numPages"
      :key="i"
      :src="url"
      :page="i"
    ></pdf>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: { pdf },
  props: {
    // pdf地址
    url: {
      type: String,
      default: "",
    },
    //每次加载
    size: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      numPages: 0,
      pages: 0, //总页数
      next: true,
      pdfLoading: false,
    };
  },
  watch: {
    url: {
      handler(val) {
        if (val) {
          this.initPdf();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 初始化pdf
    initPdf() {
      const that = this;
      const pdfSrc = pdf.createLoadingTask(that.url);
      pdfSrc.promise.then((page) => {
        that.pages = page.numPages;
        if (page.numPages <= that.size) {
          that.numPages = page.numPages;
          that.next = false;
        } else {
          that.numPages = that.size;
          that.next = true;
        }
        that.pdfLoading = false;
      });
    },
    /**
     * 加载pdf
     */
    loadPage() {
      if (this.next && !this.pdfLoading) {
        let prePage = this.numPages + this.size;
        if (prePage >= this.pages) {
          this.numPages = this.pages;
          this.next = false;
        } else {
          this.numPages = prePage;
          this.next = true;
        }
      }
    },
  },
};
</script>